document.addEventListener('DOMContentLoaded', function() {
  // Warm up likely next pages to make navigation feel instant.
  var prefetchedUrls = {};
  var canUsePrefetch = true;
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.has('test_event_code') || sessionStorage.getItem('pp_test_event_code')) {
      canUsePrefetch = false;
    }
  } catch (e) {
    /* no-op */
  }
  var network = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (network) {
    if (network.saveData) canUsePrefetch = false;
    if (network.effectiveType && /2g/.test(network.effectiveType)) canUsePrefetch = false;
  }

  function prefetchInternalLink(href) {
    try {
      if (!canUsePrefetch) return;
      if (!href || prefetchedUrls[href]) return;
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      if (url.pathname.indexOf('/cart') === 0 || url.pathname.indexOf('/checkout') === 0) return;
      if (url.pathname.indexOf('/products/') === 0) return;

      prefetchedUrls[href] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'document';
      link.href = url.href;
      document.head.appendChild(link);
    } catch (e) {
      /* no-op */
    }
  }

  function bindPrefetchListeners() {
    if (!canUsePrefetch) return;

    document.addEventListener('mouseover', function(e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      prefetchInternalLink(a.href);
    }, true);

    document.addEventListener('touchstart', function(e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      prefetchInternalLink(a.href);
    }, { passive: true, capture: true });

    document.addEventListener('focusin', function(e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      prefetchInternalLink(a.href);
    }, true);
  }

  if (window.requestIdleCallback) requestIdleCallback(bindPrefetchListeners, { timeout: 2000 });
  else setTimeout(bindPrefetchListeners, 1200);

  // Mobile Menu
  var menuBtn = document.getElementById('menuToggle');
  var menuClose = document.getElementById('menuClose');
  var menu = document.getElementById('mobileMenu');
  var overlay = document.getElementById('menuOverlay');

  if (menuBtn && menu) {
    menuBtn.addEventListener('click', function() {
      menu.classList.add('open');
      if (overlay) overlay.classList.add('open');
    });
  }
  if (menuClose && menu) {
    menuClose.addEventListener('click', function() {
      menu.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
    });
  }
  if (overlay && menu) {
    overlay.addEventListener('click', function() {
      menu.classList.remove('open');
      overlay.classList.remove('open');
    });
  }

  // Mobile Dropdowns handled via inline failsafes in header.liquid for maximum reliability


  // --- SETTINGS DROPDOWN ---
  document.addEventListener('click', function(e) {
    var settingsToggle = e.target.closest('#settingsToggle');
    var settingsDropdown = document.getElementById('settingsDropdown');
    
    if (settingsToggle) {
      e.preventDefault();
      e.stopPropagation();
      settingsDropdown.classList.toggle('active');
      settingsToggle.classList.toggle('active');
      var isActive = settingsDropdown.classList.contains('active');
      settingsToggle.setAttribute('aria-expanded', isActive);
    } else if (settingsDropdown && !settingsDropdown.contains(e.target)) {
      settingsDropdown.classList.remove('active');
      var trigger = document.getElementById('settingsToggle');
      if (trigger) {
        trigger.classList.remove('active');
        trigger.setAttribute('aria-expanded', 'false');
      }
    }
  });

  // --- SEARCH MODAL & LOGIC ---
  var headerSearchInput = document.getElementById('headerSearchInput');
  var searchModal = document.getElementById('searchModal');
  var searchModalClose = document.getElementById('searchModalClose');

  if (headerSearchInput && searchModal) {
    headerSearchInput.addEventListener('focus', function() {
      searchModal.classList.add('open');
      document.body.style.overflow = 'hidden';
      // Sync value
      var modalInput = document.getElementById('predictiveSearchInput');
      if (modalInput) {
        modalInput.value = headerSearchInput.value;
        modalInput.focus();
      }
    });
  }

  if (searchModalClose && searchModal) {
    searchModalClose.addEventListener('click', function() {
      searchModal.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // Modal Category Dropdown
  var modalCatDropdown = document.getElementById('modalCatDropdown');
  if (modalCatDropdown) {
    modalCatDropdown.addEventListener('click', function(e) {
      modalCatDropdown.classList.toggle('active');
    });

    var modalOptions = modalCatDropdown.querySelectorAll('.option');
    for (var j = 0; j < modalOptions.length; j++) {
      (function(opt) {
        opt.addEventListener('click', function(e) {
          e.stopPropagation();
          var val = opt.dataset.value;
          var label = opt.innerText;
          document.getElementById('modalSelectedCat').innerText = label;
          document.getElementById('modalSearchType').value = val === 'all' ? 'product' : val;
          
          var allOpts = modalCatDropdown.querySelectorAll('.option');
          for (var k = 0; k < allOpts.length; k++) allOpts[k].classList.remove('active');
          
          opt.classList.add('active');
          modalCatDropdown.classList.remove('active');
        });
      })(modalOptions[j]);
    }
  }

  // Dark/Light Mode Switcher
  var themeToggle = document.getElementById('themeToggle');
  var settingsThemeToggle = document.getElementById('settingsThemeToggle');
  var htmlTemplate = document.documentElement;
  
  var savedTheme = localStorage.getItem('theme-preference');
  if (savedTheme && !(window.Shopify && window.Shopify.designMode)) {
    htmlTemplate.setAttribute('data-theme', savedTheme);
  }

  function toggleThemeLogic(e) {
    if (e) e.stopPropagation();
    var currentTheme = htmlTemplate.getAttribute('data-theme');
    var newTheme = currentTheme === 'dark' ? 'light' : 'dark';
    htmlTemplate.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme-preference', newTheme);
  }

  if (themeToggle) {
    themeToggle.addEventListener('click', toggleThemeLogic);
  }
  if (settingsThemeToggle) {
    settingsThemeToggle.addEventListener('click', toggleThemeLogic);
  }

  // Filter Pills (for featured collection blocks)
  var pills = document.querySelectorAll('.pill');
  for (var l = 0; l < pills.length; l++) {
    (function(pill) {
      pill.addEventListener('click', function() {
        var container = pill.closest('.filter-pills');
        if (container) {
          var containerPills = container.querySelectorAll('.pill');
          for (var m = 0; m < containerPills.length; m++) containerPills[m].classList.remove('active');
          pill.classList.add('active');
          
          var grid = document.getElementById('featuredGrid');
          if (grid) {
            grid.style.opacity = '0.3';
            setTimeout(function() { grid.style.opacity = '1'; }, 300);
          }
        }
      });
    })(pills[l]);
  }

  // Loyalty Points Bridge - Optimized (ES5 for compatibility)
  var isSyncing = false;
  function syncLoyaltyPoints() {
    if (isSyncing) return;
    isSyncing = true;
    
    var pointsElements = document.querySelectorAll('.loyalty-points-balance');
    var foundValue = null;
    
    for (var i = 0; i < pointsElements.length; i++) {
      var el = pointsElements[i];
      if (el.tagName === 'SPAN') {
        var val = el.innerText.trim();
        if (val !== '0' && val !== '---' && val !== '' && !isNaN(val.replace(/,/g, ''))) {
          foundValue = val;
          break;
        }
      }
    }
    
    if (foundValue !== null) {
      for (var j = 0; j < pointsElements.length; j++) {
        var el2 = pointsElements[j];
        if (el2.tagName === 'SPAN' && el2.innerText.trim() !== foundValue) {
          el2.innerText = foundValue;
        }
      }
    }
    
    isSyncing = false;
  }

  var runLoyaltySync = function() {
    var targets = document.querySelectorAll('.loyalty-points-balance');
    if (!targets.length) return;

    syncLoyaltyPoints();
    setInterval(syncLoyaltyPoints, 20000);
    if (window.MutationObserver) {
      var observer = new MutationObserver(function(mutations) {
        var shouldSync = false;
        for (var k = 0; k < mutations.length; k++) {
          if (mutations[k].type === 'characterData' || mutations[k].type === 'childList') {
            shouldSync = true;
            break;
          }
        }
        if (shouldSync && !isSyncing) syncLoyaltyPoints();
      });
      
      for (var l = 0; l < targets.length; l++) {
        observer.observe(targets[l], { childList: true, characterData: true, subtree: true });
      }
    }
  };
  if (window.requestIdleCallback) requestIdleCallback(runLoyaltySync);
  else setTimeout(runLoyaltySync, 3000);

  // Countdown timers
  var countdowns = document.querySelectorAll('.countdown[data-end]');
  for (var n = 0; n < countdowns.length; n++) {
    (function(el) {
      var rawDate = el.dataset.end;
      if (!rawDate) return;
      var endDateObj = new Date(rawDate.replace(/-/g, '/'));
      if (isNaN(endDateObj.getTime())) endDateObj = new Date(rawDate);
      var endDate = endDateObj.getTime();
      var startDate = el.dataset.start ? new Date(el.dataset.start.replace(/-/g, '/')).getTime() : Date.now();
      
      var dEl = el.querySelector('[data-cd="d"]'), hEl = el.querySelector('[data-cd="h"]'), mEl = el.querySelector('[data-cd="m"]'), sEl = el.querySelector('[data-cd="s"]');
      var progBar = document.getElementById('launchProgress'), progPerc = document.getElementById('progressPercent');

      var countdownTimer = setInterval(function() {
        var now = Date.now(), diff = Math.max(0, endDate - now);
        var total = endDate - startDate, elapsed = now - startDate;
        var progress = total > 0 ? Math.min(100, Math.max(0, (elapsed / total) * 100)) : 0;
        
        if (progBar) progBar.style.width = progress + '%';
        if (progPerc) progPerc.textContent = Math.floor(progress) + '%';

        var d = Math.floor(diff / 86400000), h = Math.floor((diff % 86400000) / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
        if (dEl) dEl.textContent = String(d).padStart(2, '0');
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');

        if (diff === 0) clearInterval(countdownTimer);
      }, 1000);
    })(countdowns[n]);
  }

  // Search Modal
  var sModal = document.getElementById('searchModal');
  var hSearchInput = document.getElementById('headerSearchInput');
  var sModalClose = document.getElementById('searchModalClose');
  var pInput = document.getElementById('predictiveSearchInput');
  var rWrap = document.getElementById('predictiveSearchResults');
  var pList = document.getElementById('predictiveProductList');
  var vBtn = document.getElementById('voiceSearchBtn');
  var mCatDropdown = document.getElementById('modalCatDropdown');
  var mSelectedCat = document.getElementById('modalSelectedCat');
  var mSearchType = document.getElementById('modalSearchType');

  if (mCatDropdown) {
    mCatDropdown.addEventListener('click', function(e) {
      e.stopPropagation();
      this.classList.toggle('open');
    });

    document.addEventListener('click', function() {
      mCatDropdown.classList.remove('open');
    });

    var mOptions = mCatDropdown.querySelectorAll('.option');
    for (var o = 0; o < mOptions.length; o++) {
      (function(option) {
        option.addEventListener('click', function(e) {
          e.stopPropagation();
          var val = this.dataset.value;
          var label = this.textContent;
          
          var allMOptions = mCatDropdown.querySelectorAll('.option');
          for (var p = 0; p < allMOptions.length; p++) allMOptions[p].classList.remove('active');
          this.classList.add('active');
          
          if (mSelectedCat) mSelectedCat.textContent = label;
          if (mSearchType) mSearchType.value = val;
          
          mCatDropdown.classList.remove('open');
          
          if (pInput && pInput.value.trim().length > 0) {
            pInput.dispatchEvent(new Event('input'));
          }
        });
      })(mOptions[o]);
    }
  }

  if (hSearchInput && sModal) {
    hSearchInput.addEventListener('click', function(e) {
      e.preventDefault();
      sModal.classList.add('active');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { if (pInput) pInput.focus(); }, 200);
    });
  }

  if (sModalClose) {
    sModalClose.addEventListener('click', function() {
      sModal.classList.remove('active');
      document.body.style.overflow = '';
      if (pInput) pInput.value = '';
      if (rWrap) rWrap.style.display = 'none';
    });
  }

  if (sModal && pInput) {
    sModal.addEventListener('click', function(e) {
      if (e.target === sModal && pInput.value.trim().length === 0) {
        sModal.classList.remove('active');
        document.body.style.overflow = '';
        if (rWrap) rWrap.style.display = 'none';
      }
    });
  }

  // Predictive Search Logic
  if (pInput) {
    var dTimer;
    pInput.addEventListener('input', function() {
      clearTimeout(dTimer);
      var query = pInput.value.trim();
      
      if (query.length === 0) {
        if (rWrap) rWrap.style.display = 'none';
        return;
      }

      if (rWrap) rWrap.style.display = 'block';
      
      if (pList) {
        pList.innerHTML = '<div class="shimmer-item"><div class="shimmer-img"></div><div style="flex:1;"><div class="shimmer-line"></div><div class="shimmer-line short"></div></div></div>' +
                          '<div class="shimmer-item"><div class="shimmer-img"></div><div style="flex:1;"><div class="shimmer-line"></div><div class="shimmer-line short"></div></div></div>';
      }

      var currentCat = mSearchType ? mSearchType.value : 'all';
      var filterQuery = "";
      if (currentCat === 'game') filterQuery = " AND product_type:Game";
      if (currentCat === 'gift-card') filterQuery = " AND product_type:Gift Card";
      
      var fullQuery = query + filterQuery;

      dTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(fullQuery) + '&resources[type]=query,product&resources[limit]=4')
          .then(function(res) { return res.json(); })
          .then(function(data) {
            var suggestions = data.resources.results.queries;
            var products = data.resources.results.products;
            
            var sArea = document.querySelector('.suggestion-pills');
            var sGroup = document.querySelector('.suggestions-group');
            if (sArea) {
              if (suggestions && suggestions.length > 0) {
                if (sGroup) sGroup.style.display = 'block';
                sArea.innerHTML = suggestions.map(function(s) { return '<button type="button" class="s-pill dynamic-chip">' + s.text + '</button>'; }).join('');
                
                var chips = sArea.querySelectorAll('.dynamic-chip');
                for (var q = 0; q < chips.length; q++) {
                  (function(chip) {
                    chip.addEventListener('click', function() {
                      pInput.value = this.textContent;
                      pInput.dispatchEvent(new Event('input'));
                      pInput.focus();
                    });
                  })(chips[q]);
                }
              } else {
                if (sGroup) sGroup.style.display = 'none';
              }
            }

            if (products && products.length > 0 && pList) {
              var pHtml = products.map(function(p) { return '<a href="'+p.url+'" class="predictive-product-item"><div class="p-img-wrap"><img src="'+p.image+'" alt="'+p.title+'"></div><div class="p-info"><span class="p-title">'+p.title+'</span><span class="p-price">'+p.price+'</span></div></a>'; }).join('');
              pList.innerHTML = pHtml;
            } else if (pList) {
              pList.innerHTML = '<div class="modal-empty-state">No products found for "' + query + '"</div>';
            }
          });
      }, 300);
    });
  }

  var sPills = document.querySelectorAll('.s-pill');
  for (var r = 0; r < sPills.length; r++) {
    (function(chip) {
      chip.addEventListener('click', function() {
        if (pInput) {
          pInput.value = this.textContent;
          pInput.dispatchEvent(new Event('input'));
          pInput.focus();
        }
      });
    })(sPills[r]);
  }

  // Voice Search Implementation
  if (vBtn) {
    var SRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    var recognition = SRecognition ? new SRecognition() : null;

    vBtn.addEventListener('click', function() {
      if (!pInput) return;
      pInput.value = "";
      pInput.placeholder = "Listening...";
      vBtn.style.color = "var(--pink)";

      if (recognition) {
        recognition.start();
        recognition.onresult = function(event) {
          var transcript = event.results[0][0].transcript;
          pInput.value = transcript;
          pInput.placeholder = "Search for games, accounts, keys...";
          vBtn.style.color = "";
          pInput.dispatchEvent(new Event('input'));
          recognition.stop();
        };
        recognition.onerror = function() {
          vBtn.style.color = "red";
          setTimeout(function() { vBtn.style.color = ""; }, 1000);
        };
      } else {
        setTimeout(function() {
          pInput.placeholder = "Search for games, accounts, keys...";
          pInput.value = "Ghost of Tsushima";
          vBtn.style.color = "";
          pInput.dispatchEvent(new Event('input'));
        }, 1500);
      }
    });
  }
  // Load More Functionality for Featured Collection
  var loadMoreBtn = document.getElementById('loadMoreBtn');
  if (loadMoreBtn) {
    var page = 1;
    loadMoreBtn.addEventListener('click', function() {
      var collection = this.dataset.collection;
      var limit = parseInt(this.dataset.limit) || 4;
      page++;
      var grid = document.getElementById('featuredGrid');

      if (!collection || !grid) return;

      loadMoreBtn.classList.add('loading');

      fetch('/collections/' + collection + '?page=' + page)
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('featuredGrid');
          
          if (newGrid) {
            var products = newGrid.querySelectorAll('.product-card');
            if (products.length > 0) {
              for (var i = 0; i < products.length; i++) {
                (function(p) {
                  p.style.opacity = '0';
                  p.style.transform = 'translateY(20px)';
                  grid.appendChild(p);
                  setTimeout(function() { 
                    p.style.transition = 'all 0.5s ease-out';
                    p.style.opacity = '1'; 
                    p.style.transform = 'translateY(0)';
                  }, 50);
                })(products[i]);
              }
              
              if (products.length < limit) {
                loadMoreBtn.style.display = 'none';
              }
            } else {
              loadMoreBtn.style.display = 'none';
            }
          } else {
            loadMoreBtn.style.display = 'none';
          }
        })
        ["catch"](function() {
          loadMoreBtn.classList.remove('loading');
        })
        ["finally"](function() {
          loadMoreBtn.classList.remove('loading');
        });
    });
  }
  // Recently Viewed Tracking Logic
  (function() {
    var path = window.location.pathname;
    if (path.indexOf('/products/') > -1) {
      var handle = path.split('/products/')[1].split('?')[0].split('#')[0];
      if (handle) {
        var viewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
        var index = viewed.indexOf(handle);
        if (index > -1) viewed.splice(index, 1);
        viewed.unshift(handle);
        localStorage.setItem('recentlyViewed', JSON.stringify(viewed.slice(0, 10)));
      }
    }
  })();
});

/* === Cart Drawer AJAX Logic === */
window.openCartDrawer = function() {
  if (window.revealHeaderForCartNotice) window.revealHeaderForCartNotice();
  var drawer = document.getElementById('CartDrawer');
  if(drawer) drawer.classList.add('active');
  if (window.fetchCartAndRender) window.fetchCartAndRender();
  if(window.completeCyberBar) window.completeCyberBar();
};

window.closeCartDrawer = function() {
  var drawer = document.getElementById('CartDrawer');
  if(drawer) drawer.classList.remove('active');
};

window.syncHeaderCartCount = function(count) {
  var parsed = parseInt(count, 10);
  if (isNaN(parsed) || parsed < 0) parsed = 0;

  var cartLinks = document.querySelectorAll('.cart-badge');
  for (var i = 0; i < cartLinks.length; i++) {
    var link = cartLinks[i];
    var badge = link.querySelector('.cart-count');
    if (parsed > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-count';
        link.appendChild(badge);
      }
      badge.textContent = parsed;
      badge.style.display = 'flex';
    } else if (badge) {
      badge.parentNode.removeChild(badge);
    }
    link.setAttribute('aria-label', 'Shopping Cart with ' + parsed + ' items');
  }

  var displays = document.querySelectorAll('.cart-count-display');
  for (var j = 0; j < displays.length; j++) {
    displays[j].textContent = parsed;
  }
};

window.normalizePurchaseFlowError = function(error, fallback) {
  var message = fallback || 'Something went wrong. Please review your cart and try again.';
  if (!error) return message;
  if (typeof error === 'string') return error;
  if (error.description) return error.description;
  if (error.message) return error.message;
  if (error.errors) {
    if (typeof error.errors === 'string') return error.errors;
    try {
      var keys = Object.keys(error.errors);
      if (keys.length) {
        var first = error.errors[keys[0]];
        if (Array.isArray(first)) return first[0];
        if (typeof first === 'string') return first;
      }
    } catch(e) {}
  }
  return message;
};

window.showPurchaseFlowMessage = function(message, options) {
  options = options || {};
  var tone = options.tone || 'error';
  var target = options.target || null;
  var container = options.container || null;

  if (!target && typeof options.targetSelector === 'string') {
    target = document.querySelector(options.targetSelector);
  }

  if (!target && container && container.querySelector) {
    target = container.querySelector('[data-purchase-flow-message]');
    if (!target) {
      target = document.createElement('div');
      target.setAttribute('data-purchase-flow-message', '');
      target.className = 'pp-purchase-flow-message';
      var anchor = container.querySelector('.custom-cart-row, .product-btns-group, button[type="submit"]');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(target, anchor);
      else container.appendChild(target);
    }
  }

  if (!target) {
    target =
      document.getElementById('CartDrawerMessage') ||
      document.getElementById('CartPageMessage') ||
      document.querySelector('[data-purchase-flow-message]');
  }

  if (!target) return;

  target.textContent = message || 'Something went wrong. Please try again.';
  target.hidden = false;
  target.classList.remove('is-error', 'is-success', 'is-info');
  target.classList.add('is-' + tone);
  target.setAttribute('role', tone === 'error' ? 'alert' : 'status');

  if (options.persist) return;
  clearTimeout(target.__ppMessageTimer);
  target.__ppMessageTimer = setTimeout(function() {
    target.hidden = true;
  }, options.timeout || 6500);
};

window.ppGetShopifyRoute = window.ppGetShopifyRoute || function(path) {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  return root + String(path || '').replace(/^\//, '');
};

window.ppParseCartResponse = window.ppParseCartResponse || function(response) {
  return response.text().then(function(text) {
    var data = {};
    if (text) {
      try {
        data = JSON.parse(text);
      } catch (error) {
        data = {
          status: response.status,
          description: text.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
        };
      }
    }
    if (!response.ok || data.status) throw data;
    return data;
  });
};

window.afterSuccessfulCartAdd = function(product, qty, options) {
  options = options || {};
  if (window.openAddToCartNotice) window.openAddToCartNotice(product, qty);
  if (window.openCartDrawer) {
    setTimeout(function() {
      window.openCartDrawer();
      window.showPurchaseFlowMessage('Added to cart. Review your items below or proceed to checkout.', {
        targetSelector: '#CartDrawerMessage',
        tone: 'success',
        timeout: 4200
      });
    }, 80);
  } else if (window.fetchCartAndRender) {
    window.fetchCartAndRender();
  }
  if (options.container) {
    window.showPurchaseFlowMessage('Added to cart. You can proceed to checkout or view the full cart.', {
      container: options.container,
      tone: 'success',
      timeout: 4200
    });
  }
};

window.openAddToCartNotice = function(product, qty) {
  if (window.revealHeaderForCartNotice) window.revealHeaderForCartNotice();
  if (window.updateCartNoticeOffset) window.updateCartNoticeOffset();
  var modal = document.getElementById('AddToCartNotice');
  if (!modal || !product) return;
  if (window.__cartNoticeCloseTimer) {
    clearTimeout(window.__cartNoticeCloseTimer);
    window.__cartNoticeCloseTimer = null;
  }
  modal.classList.remove('closing');
  var title = document.getElementById('CartNoticeTitle');
  var variant = document.getElementById('CartNoticeVariant');
  var image = document.getElementById('CartNoticeImage');
  var viewCart = document.getElementById('CartNoticeViewCart');
  var head = document.getElementById('CartNoticeHead');
  var checkout = document.getElementById('CartNoticeCheckout');
  var cont = document.getElementById('CartNoticeContinue');
  var docDir = (document.documentElement.getAttribute('dir') || '').toLowerCase();
  var docLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var isArabic = docDir === 'rtl' || docLang.indexOf('ar') === 0 || modal.getAttribute('data-is-ar') === 'true';
  modal.classList.toggle('is-rtl', isArabic);
  modal.setAttribute('dir', isArabic ? 'rtl' : 'ltr');

  var labelAdded = modal.getAttribute(isArabic ? 'data-label-added-ar' : 'data-label-added-en') || 'Item added to your cart';
  var labelView = modal.getAttribute(isArabic ? 'data-label-view-cart-ar' : 'data-label-view-cart-en') || 'View cart';
  var labelCheckout = modal.getAttribute(isArabic ? 'data-label-checkout-ar' : 'data-label-checkout-en') || 'Check out';
  var labelContinue = modal.getAttribute(isArabic ? 'data-label-continue-ar' : 'data-label-continue-en') || 'Continue shopping';
  var labelType = modal.getAttribute(isArabic ? 'data-label-type-ar' : 'data-label-type-en') || 'Type';
  if (head) head.textContent = labelAdded;
  if (checkout) checkout.textContent = labelCheckout;
  if (cont) cont.textContent = labelContinue;

  if (title) title.textContent = product.product_title || product.title || 'Product';
  if (variant) variant.textContent = product.variant_title ? (labelType + ': ' + product.variant_title) : '';
  if (image) {
    var resolvedImage = '';
    if (product.image) {
      if (/^https?:\/\//i.test(product.image)) resolvedImage = product.image;
      else if (product.image.indexOf('//') === 0) resolvedImage = 'https:' + product.image;
      else resolvedImage = product.image;
    }
    if (!resolvedImage) {
      var pageImage = document.querySelector('.gallery-main-image img, .product-gallery-wrap img, .product-card img');
      if (pageImage && pageImage.src) resolvedImage = pageImage.src;
    }
    image.src = resolvedImage;
    image.alt = product.product_title || product.title || 'Product';
  }
  var addedQty = parseInt(qty, 10);
  if (isNaN(addedQty) || addedQty < 1) addedQty = 1;
  var cartBadge = document.querySelector('.cart-count, .cart-count-display');
  var currentCount = cartBadge ? parseInt((cartBadge.textContent || '0').replace(/[^\d]/g, ''), 10) : 0;
  if (isNaN(currentCount)) currentCount = 0;
  var nextCount = currentCount + addedQty;
  window.syncHeaderCartCount(nextCount);
  if (viewCart) viewCart.textContent = labelView + ' (' + nextCount + ')';

  modal.classList.add('active');
  modal.setAttribute('aria-hidden', 'false');

  // One delayed settle pass only (no live tracking/no jitter).
  if (window.updateCartNoticeOffset) setTimeout(window.updateCartNoticeOffset, 90);
};

window.updateCartNoticeOffset = function() {
  var target =
    document.querySelector('.sticky-header-host .header') ||
    document.querySelector('.sticky-header-host .header-reveal-wrapper') ||
    document.querySelector('.sticky-header-host');
  if (!target) return;

  var rect = target.getBoundingClientRect();
  if (!rect) return;

  var rawBottom = Math.round(rect.bottom);
  var top = rawBottom + 10;
  // Guard against hidden/transformed header measurements.
  if (rawBottom > 220) top = 96;
  if (rawBottom < 0) top = 12;
  if (top < 8) top = 8;
  document.documentElement.style.setProperty('--cart-notice-top', top + 'px');
};

window.revealHeaderForCartNotice = function() {
  var stickyHost = document.querySelector('.sticky-header-host');
  var headerSection = stickyHost ? stickyHost.closest('.section-header') : document.querySelector('.section-header');
  if (!headerSection) return;

  headerSection.classList.remove('shopify-section-header-hidden');
  headerSection.classList.add('shopify-section-header-sticky', 'animate');
  if (window.updateCartNoticeOffset) window.updateCartNoticeOffset();
};

window.closeAddToCartNotice = function() {
  var modal = document.getElementById('AddToCartNotice');
  if (!modal) return;
  modal.classList.add('closing');
  if (window.__cartNoticeCloseTimer) clearTimeout(window.__cartNoticeCloseTimer);
  window.__cartNoticeCloseTimer = setTimeout(function() {
    modal.classList.remove('active');
    modal.classList.remove('closing');
    modal.setAttribute('aria-hidden', 'true');
    window.__cartNoticeCloseTimer = null;
  }, 380);
};

window.addEventListener('resize', function() {
  if (window.updateCartNoticeOffset) window.updateCartNoticeOffset();
});

window.findCartDrawerLineItem = function(line) {
  return document.querySelector('.cart-drawer__item[data-line="' + line + '"]');
};

window.setCartDrawerQtyLoading = function(line, isLoading) {
  var lineItem = window.findCartDrawerLineItem(line);
  if (!lineItem) return;
  var picker = lineItem.querySelector('.qty-picker');
  if (!picker) return;
  if (isLoading) picker.classList.add('is-loading');
  else picker.classList.remove('is-loading');
};

window.bumpCartDrawerQty = function(line) {
  var lineItem = window.findCartDrawerLineItem(line);
  if (!lineItem) return;
  var picker = lineItem.querySelector('.qty-picker');
  if (!picker) return;
  picker.classList.remove('is-bump');
  picker.offsetHeight;
  picker.classList.add('is-bump');
  setTimeout(function() { picker.classList.remove('is-bump'); }, 220);
};

window.showCartDrawerStockError = function(line, message) {
  var lineItem = window.findCartDrawerLineItem(line);
  if (!lineItem) return;

  var host = lineItem.querySelector('.cart-drawer__item-details') || lineItem;
  var errorEl = lineItem.querySelector('.cart-drawer__stock-error');
  if (!errorEl) {
    errorEl = document.createElement('div');
    errorEl.className = 'cart-drawer__stock-error';
    host.appendChild(errorEl);
  }

  errorEl.textContent = message || "Sorry, that's all we got right now!";
  errorEl.style.display = 'block';

  lineItem.classList.remove('is-shaking');
  lineItem.offsetHeight;
  lineItem.classList.add('is-shaking');

  setTimeout(function() {
    lineItem.classList.remove('is-shaking');
  }, 360);

  setTimeout(function() {
    if (errorEl) errorEl.style.display = 'none';
  }, 2600);
};

window.ensureCartDrawerUX = function() {
  if (document.getElementById('CartDrawerUXStyles')) return;
  var style = document.createElement('style');
  style.id = 'CartDrawerUXStyles';
  style.textContent =
    '.cart-drawer__stock-error{display:none;color:var(--pink);font-size:12px;font-weight:700;margin-top:8px;line-height:1.35;}' +
    '.qty-picker.is-bump{animation:cartQtyBump .22s ease;}' +
    '.cart-drawer__item.is-shaking{animation:cartLineShake .36s ease;}' +
    '@keyframes cartQtyBump{0%{transform:scale(1)}50%{transform:scale(1.06)}100%{transform:scale(1)}}' +
    '@keyframes cartLineShake{0%,100%{transform:translateX(0)}20%{transform:translateX(-5px)}40%{transform:translateX(5px)}60%{transform:translateX(-3px)}80%{transform:translateX(3px)}}';
  document.head.appendChild(style);
};

window.updateCartItem = function(line, qty) {
  window.setCartDrawerQtyLoading(line, true);
  window.bumpCartDrawerQty(line);

  var currentItem = window.findCartDrawerLineItem(line);
  if (currentItem) {
    currentItem.classList.add(qty === 0 ? 'is-removing' : 'is-updating');
  }

  try {
    var formData = { line: line, quantity: qty };
    var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    if (root.slice(-1) === '/') root = root.slice(0, -1);

    fetch(root + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(formData)
    })
    .then(function(res) {
      if (res.ok) return res.json();
      return res.json()
        .then(function(data) {
          var msg = data && (data.description || data.message) ? (data.description || data.message) : null;
          throw new Error(msg || 'Cart update failed');
        });
    })
    .then(function() {
      if (window.fetchCartAndRender) window.fetchCartAndRender();
      else window.location.reload();
    })
    ["catch"](function(err) {
      console.error('Cart update failed:', err);
      window.showCartDrawerStockError(line, err && err.message ? err.message : null);
      window.setCartDrawerQtyLoading(line, false);
    });
  } catch(e) {
    console.error('updateCartItem error:', e);
    window.showCartDrawerStockError(line, null);
  }
  setTimeout(function() {
    window.setCartDrawerQtyLoading(line, false);
    var refreshedItem = window.findCartDrawerLineItem(line);
    if (refreshedItem) refreshedItem.classList.remove('is-updating');
  }, 800);
};

window.removeCartLineFast = function(line, lineItem) {
  var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
  if (root.slice(-1) === '/') root = root.slice(0, -1);

  if (lineItem) {
    lineItem.classList.add('is-removing');
    lineItem.style.pointerEvents = 'none';
  }

  fetch(root + '/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
  })
  .then(function(res) {
    if (!res.ok) throw new Error('Remove item request failed');
    return res.json();
  })
  .then(function() {
    setTimeout(function() {
      if (window.fetchCartAndRender) window.fetchCartAndRender();
      else window.location.reload();
    }, 80);
  })
  ["catch"](function() {
    window.location.href = '/cart/change?line=' + line + '&quantity=0';
  });
};

/* Global Click Interceptor for Remove Buttons */
document.addEventListener('click', function(e) {
  var removeBtn = e.target.closest('.cc-remove-btn, .cart-drawer__remove');
  if (removeBtn) {
    e.preventDefault();
    e.stopPropagation();
    
    var lineItem = removeBtn.closest('[data-line]');
    var line = lineItem ? lineItem.dataset.line : null;
    
    if (line) {
      removeBtn.innerHTML = '<span class="btn-cart-spinner"></span>';
      lineItem.style.pointerEvents = 'none';
      window.removeCartLineFast(line, lineItem);
    }
  }
}, true);

window.fetchCartAndRender = function() {
  fetch('/?section_id=cart-drawer')
    .then(function(res) { return res.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      
      var newCartHTML = doc.getElementById('CartDrawerItems');
      var oldCartHTML = document.getElementById('CartDrawerItems');
      if (newCartHTML && oldCartHTML) oldCartHTML.innerHTML = newCartHTML.innerHTML;
      
      var newTotal = doc.getElementById('CartDrawerTotal');
      var oldTotal = document.getElementById('CartDrawerTotal');
      if (newTotal && oldTotal) oldTotal.innerHTML = newTotal.innerHTML;
      
      var newCount = doc.getElementById('CartDrawerCount');
      var oldCount = document.getElementById('CartDrawerCount');
      if (oldCount && newCount) {
        oldCount.innerHTML = newCount.innerHTML;
      } else if (oldCount && !newCount) {
        oldCount.parentNode.removeChild(oldCount);
      }
      
      var newFooter = doc.querySelector('.cart-drawer__footer');
      var oldFooter = document.querySelector('.cart-drawer__footer');
      var newInner = doc.querySelector('.cart-drawer__inner');
      var oldInner = document.querySelector('.cart-drawer__inner');
      
      if (oldFooter && !newFooter) {
        oldFooter.parentNode.removeChild(oldFooter);
      } else if (!oldFooter && newFooter && oldInner) {
        oldInner.appendChild(newFooter);
      } else if (oldFooter && newFooter) {
        oldFooter.innerHTML = newFooter.innerHTML;
      }
    });

  if (window.location.pathname.indexOf('/cart') > -1) {
    try {
      var cartSection = document.getElementById('CyberCartContainer');
      var sectionId = 'main';
      if (cartSection) {
         var sectionEl = cartSection.closest('.shopify-section');
         if (sectionEl) sectionId = sectionEl.id.replace('shopify-section-', '');
      }

      fetch('/?section_id=' + sectionId)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          
          var targets = ['CyberCartContainer', 'CartDrawerItems', 'CartDrawerTotal', 'CartDrawerCount'];
          for (var i = 0; i < targets.length; i++) {
             var id = targets[i];
             var newEl = doc.getElementById(id);
             var oldEl = document.getElementById(id);
             if(newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
          }
        })
        ["catch"](function(e) { console.error('Cart render fetch error:', e); });
    } catch(e) {
      console.error('Cart render error:', e);
    }
  }

  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
     window.syncHeaderCartCount(cart.item_count);
  })
  ["catch"](function(err) { console.error("Drawer render error:", err); });
};

window.setCheckoutButtonState = function(button, isLoading) {
  if (!button) return;
  if (isLoading) {
    if (!button.getAttribute('data-pp-original-label')) {
      button.setAttribute('data-pp-original-label', button.innerHTML);
    }
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (button.tagName === 'BUTTON') button.setAttribute('disabled', 'disabled');
    button.innerHTML = '<span class="btn-cart-spinner"></span> Opening secure checkout...';
  } else {
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    if (button.tagName === 'BUTTON') button.removeAttribute('disabled');
    var original = button.getAttribute('data-pp-original-label');
    if (original) button.innerHTML = original;
  }
};

window.startCheckoutSafely = function(trigger) {
  if (window.__ppCheckoutStarting) return;
  window.__ppCheckoutStarting = true;
  window.setCheckoutButtonState(trigger, true);
  window.showPurchaseFlowMessage('Checking your cart before secure checkout...', {
    targetSelector: '#CartDrawerMessage',
    tone: 'info',
    persist: true
  });
  window.showPurchaseFlowMessage('Checking your cart before secure checkout...', {
    targetSelector: '#CartPageMessage',
    tone: 'info',
    persist: true
  });

  var controller = window.AbortController ? new AbortController() : null;
  var timeout = controller ? setTimeout(function() { controller.abort(); }, 5500) : null;

  fetch('/cart.js', {
    credentials: 'same-origin',
    cache: 'no-store',
    signal: controller ? controller.signal : undefined
  })
  .then(function(response) {
    if (!response.ok) throw new Error('Cart check failed');
    return response.json();
  })
  .then(function(cart) {
    if (!cart || !cart.item_count) {
      throw new Error('Your cart is empty. Please add an item before checkout.');
    }
    window.syncHeaderCartCount(cart.item_count);
    window.showPurchaseFlowMessage('Cart ready. Taking you to secure checkout now.', {
      targetSelector: '#CartDrawerMessage',
      tone: 'success',
      persist: true
    });
    window.location.href = window.ppGetShopifyRoute('/checkout');
  })
  ["catch"](function(error) {
    var message = window.normalizePurchaseFlowError
      ? window.normalizePurchaseFlowError(error, 'Checkout could not start. Please open the full cart and try again.')
      : 'Checkout could not start. Please open the full cart and try again.';
    window.__ppCheckoutStarting = false;
    window.setCheckoutButtonState(trigger, false);
    window.showPurchaseFlowMessage(message, { targetSelector: '#CartDrawerMessage', tone: 'error', persist: true });
    window.showPurchaseFlowMessage(message, { targetSelector: '#CartPageMessage', tone: 'error', persist: true });
  })
  ["finally"](function() {
    if (timeout) clearTimeout(timeout);
  });
};

document.addEventListener('DOMContentLoaded', function() {
  window.ensureCartDrawerUX();
  document.addEventListener('click', function(e) {
    var qtyBtn = e.target && e.target.closest ? e.target.closest('.qty-btn') : null;
    if (!qtyBtn) return;
    var picker = qtyBtn.closest('.qty-picker');
    if (!picker) return;
    picker.classList.remove('is-bump');
    picker.offsetHeight;
    picker.classList.add('is-bump');
    setTimeout(function() { picker.classList.remove('is-bump'); }, 220);
  }, true);
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-cart-notice-close]')) return;
    window.closeAddToCartNotice();
  }, true);
  document.addEventListener('click', function(e) {
    var checkoutLink = e.target && e.target.closest
      ? e.target.closest('a[href*="/checkout"], .btn-checkout, #CartNoticeCheckout')
      : null;
    if (!checkoutLink || checkoutLink.getAttribute('data-skip-checkout-guard') === 'true') return;
    e.preventDefault();
    e.stopPropagation();
    window.startCheckoutSafely(checkoutLink);
  }, true);
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.id !== 'cart') return;
    var submitter = e.submitter || document.activeElement;
    if (!submitter || submitter.getAttribute('name') !== 'checkout') return;
    e.preventDefault();
    window.startCheckoutSafely(submitter);
  }, true);

  var cartForms = document.querySelectorAll('form[action*="/cart/add"]');
  for (var i = 0; i < cartForms.length; i++) {
    (function(form) {
      if (form.closest && form.closest('product-form')) return;
      form.addEventListener('submit', function(e) {
        // Skip AJAX interception if this is a Buy It Now / Direct Checkout request
        if (form.getAttribute('data-skip-ajax') === 'true') return;
        e.preventDefault();
        
        var submitter = e.submitter || document.activeElement;
        var submitBtn = (submitter && submitter.matches && submitter.matches('button[type="submit"], input[type="submit"], .add-to-cart-btn'))
          ? submitter
          : form.querySelector('button[name="add"], button[type="submit"], input[type="submit"], .add-to-cart-btn');
        var btnTextSpan = submitBtn ? submitBtn.querySelector('[id^="BtnText-"], .btn-text') : null;
        var targetEl = btnTextSpan || (submitBtn ? submitBtn.querySelector('.btn-inner') : null) || submitBtn;
        var iconEl = submitBtn ? submitBtn.querySelector('[id^="BtnIcon-"], #BtnIconMain, .premium-cart-icon') : null;
        var originalHTML = targetEl ? targetEl.innerHTML : '';
        var submitDefaultLabel = submitBtn ? (submitBtn.getAttribute('data-default-label') || 'Add to cart') : 'Add to cart';
        var soldOutLabel = submitBtn ? (submitBtn.getAttribute('data-sold-out-label') || 'Sold out') : 'Sold out';

        if (form.getAttribute('data-cart-request-inflight') === 'true') {
          if (window.showPurchaseFlowMessage) {
            window.showPurchaseFlowMessage('Still processing your previous request. Please wait a moment.', {
              container: form,
              tone: 'info',
              timeout: 3000
            });
          }
          return;
        }
        form.setAttribute('data-cart-request-inflight', 'true');

        if (submitBtn && /btn-cart-spinner|adding\.\.\.|processing\.\.\./i.test(originalHTML || '')) {
          originalHTML = submitDefaultLabel;
        }
        
        if(submitBtn) {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.style.pointerEvents = 'none';
          if(targetEl) targetEl.innerHTML = '<span class="btn-cart-spinner"></span> Adding...';
        }

        var formData = new FormData(form);
        var variantId = formData.get('id');
        if (!variantId) {
          if (window.showPurchaseFlowMessage) {
            window.showPurchaseFlowMessage('Please select an available option before continuing.', { container: form, tone: 'error', persist: true });
          }
          form.setAttribute('data-cart-request-inflight', 'false');
          if (submitBtn) {
            submitBtn.removeAttribute('disabled');
            submitBtn.style.pointerEvents = 'auto';
          }
          if (targetEl) targetEl.innerHTML = originalHTML || submitDefaultLabel;
          if (iconEl) iconEl.style.display = 'inline-block';
          return;
        }
        formData.append('sections', 'cart-drawer');
        formData.append('sections_url', window.location.pathname);
        var cartAddUrl = window.ppGetShopifyRoute('/cart/add.js');

        var analyticsReady = window.ppWhenPixelRuntimeReady
          ? window.ppWhenPixelRuntimeReady(6000)
          : Promise.resolve(false);

        analyticsReady
        .catch(function() { return false; })
        .then(function() {
          return fetch(cartAddUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            }
          });
        })
        .then(function(response) {
          return window.ppParseCartResponse(response);
        })
        .then(function(product) {
          var addedQuantity = parseInt(formData.get('quantity'), 10);
          if (isNaN(addedQuantity) || addedQuantity < 1) addedQuantity = 1;

          if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: product
            });
          }

          playFlyingAnimation(form);
          if (window.afterSuccessfulCartAdd) window.afterSuccessfulCartAdd(product, addedQuantity, { container: form });
          else if (window.openAddToCartNotice) window.openAddToCartNotice(product, addedQuantity);
        })
        ["catch"](function(error) {
          console.error('Add to cart failed', error);
          var message = window.normalizePurchaseFlowError
            ? window.normalizePurchaseFlowError(error, 'We could not add this item. Please try again or open the full cart.')
            : 'We could not add this item. Please try again or open the full cart.';
          if (window.showPurchaseFlowMessage) {
            window.showPurchaseFlowMessage(message, { container: form, tone: 'error', persist: true });
            window.showPurchaseFlowMessage(message + ' You can also review your cart from the full cart page.', {
              targetSelector: '#CartDrawerMessage',
              tone: 'error',
              persist: true
            });
          }
        })
        ["finally"](function() {
          form.setAttribute('data-cart-request-inflight', 'false');
          if(submitBtn) {
            submitBtn.removeAttribute('disabled');
            submitBtn.style.pointerEvents = 'auto';
          }
          if(targetEl) {
            var selectedVariant = form.querySelector('input[name="variant_selector"]:checked');
            var isAvailable = selectedVariant ? selectedVariant.dataset.available !== 'false' : true;
            targetEl.innerHTML = isAvailable ? submitDefaultLabel : soldOutLabel;
          }
          if(iconEl) iconEl.style.display = 'inline-block';
        });
      });
    })(cartForms[i]);
  }
  
  var hCartIcons = document.querySelectorAll('.header .cart-badge, .header a[href*="/cart"]');
  for (var j = 0; j < hCartIcons.length; j++) {
      (function(icon) {
          icon.addEventListener('click', function(e) {
              e.preventDefault();
              window.openCartDrawer();
          });
      })(hCartIcons[j]);
  }
  
  function playFlyingAnimation(form) {
      var productCard = form.closest('.product-card') || form.closest('.card-inner') || form.closest('.hero-product');
      var productImage = productCard ? productCard.querySelector('img') : document.querySelector('img');
      var cartIcon = document.querySelector('.cart-badge') || document.querySelector('a[href="/cart"]');
      
      if(!productImage || !cartIcon) return;
      
      var imgClone = productImage.cloneNode(true);
      var rect = productImage.getBoundingClientRect();
      var cartRect = cartIcon.getBoundingClientRect();
      
      imgClone.classList.add('flying-product');
      imgClone.style.top = rect.top + 'px';
      imgClone.style.left = rect.left + 'px';
      imgClone.style.width = rect.width + 'px';
      imgClone.style.height = rect.height + 'px';
      imgClone.style.position = 'fixed';
      imgClone.style.zIndex = '10000000';
      imgClone.style.pointerEvents = 'none';
      imgClone.style.transition = 'all 0.8s cubic-bezier(0.1, 0.7, 0.1, 1)';
      
      document.body.appendChild(imgClone);
      
      setTimeout(function() {
          imgClone.style.top = cartRect.top + (cartRect.height / 2) + 'px';
          imgClone.style.left = cartRect.left + (cartRect.width / 2) + 'px';
          imgClone.style.width = '10px';
          imgClone.style.height = '10px';
          imgClone.style.opacity = '0';
          imgClone.style.transform = 'scale(0.1) rotate(45deg)';
      }, 50);
      
      setTimeout(function() {
          if (imgClone.parentNode) imgClone.parentNode.removeChild(imgClone);
      }, 850);
  }
});

/* === CYBER LOADING BAR LOGIC === */
document.addEventListener('DOMContentLoaded', function() {
  window.completeCyberBar = function() {
    var cyberBar = document.getElementById('cyber-loading-bar');
    if (cyberBar) {
      cyberBar.style.width = '100%';
      cyberBar.style.opacity = '0';
      setTimeout(function() { cyberBar.style.width = '0%'; }, 180);
    }
  };

  document.addEventListener('click', function(e) {
    var a = e.target.closest('a');
    if (!a || !a.href) return;

    var isJSTrigger = a.classList.contains('cart-badge') || 
                      a.classList.contains('dropdown-trigger') || 
                      a.classList.contains('settings-trigger') ||
                      a.classList.contains('menu-btn') ||
                      a.classList.contains('close-btn') ||
                      a.hasAttribute('data-no-instant') ||
                      a.getAttribute('href').indexOf('#') === 0 ||
                      a.getAttribute('href').indexOf('javascript:') === 0;

    if (!isJSTrigger && a.hostname === window.location.hostname && !a.target) {
      var cyberBar = document.getElementById('cyber-loading-bar');
      if (!cyberBar) {
        cyberBar = document.createElement('div');
        cyberBar.id = 'cyber-loading-bar';
        document.body.appendChild(cyberBar);
      }
      
      cyberBar.style.transition = 'none';
      cyberBar.style.width = '0%';
      cyberBar.style.opacity = '1';
      
      setTimeout(function() {
        cyberBar.style.transition = 'width 0.4s cubic-bezier(0.1, 0.7, 0.1, 1), opacity 0.3s ease';
        cyberBar.style.width = '65%';
      }, 10);

      setTimeout(function() {
        if (cyberBar && cyberBar.style.opacity !== '0') {
          cyberBar.style.width = '90%';
        }
      }, 300);
    }
  });

  window.addEventListener('pageshow', function(e) {
    window.completeCyberBar();
  });
});

/* === Product Recommendations Component (ES5) === */
if (window.customElements && !customElements.get('product-recommendations')) {
  function ProductRecommendations() {
    return Reflect.construct(HTMLElement, [], ProductRecommendations);
  }
  ProductRecommendations.prototype = Object.create(HTMLElement.prototype);
  ProductRecommendations.prototype.constructor = ProductRecommendations;

  ProductRecommendations.prototype.connectedCallback = function() {
    var _this = this;
    if (this.dataset.url) {
      this.load();
    } else if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function(entries) {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(_this);
        _this.load();
      });
      observer.observe(this);
    } else {
      this.load();
    }
  };

  ProductRecommendations.prototype.load = function() {
    var _this = this;
    if (this.dataset.url) {
      fetch(this.dataset.url)
        .then(function(res) { return res.text(); })
        .then(function(text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var recommendations = html.querySelector('.recommended-slider-wrapper, .product-slider');

          if (recommendations && recommendations.innerHTML.trim().length) {
            var isFallback = recommendations.classList.contains('is-fallback');
            if (_this.classList.contains('recommended-section')) {
               var internalWrapper = _this.querySelector('.recommended-slider-wrapper');
               if(internalWrapper) {
                 internalWrapper.innerHTML = recommendations.innerHTML;
                 if (window.filterRecommendationsByPlatform) window.filterRecommendationsByPlatform(_this);
                 if (isFallback) _this.randomize();
                 _this.initSlider();
               }
            } else {
               _this.innerHTML = recommendations.outerHTML;
               if (window.filterRecommendationsByPlatform) window.filterRecommendationsByPlatform(_this);
               _this.initSlider();
            }
          }
        })
        ["catch"](function(e) {
          console.error('Recommendations fetch failed', e);
          _this.randomize();
          _this.initSlider();
        });
    } else {
      _this.randomize();
      _this.initSlider();
    }
  };

  ProductRecommendations.prototype.randomize = function() {
    var track = this.querySelector('.recommended-slider-track, .product-slider');
    if (!track) return;

    var slideList = track.querySelectorAll('.recommended-slide, .slider-item-wrap');
    var slides = [];
    for (var i = 0; i < slideList.length; i++) slides.push(slideList[i]);
    
    if (slides.length <= 1) return;

    for (var i = slides.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = slides[i];
      slides[i] = slides[j];
      slides[j] = temp;
    }

    for (var i = 0; i < slides.length; i++) track.appendChild(slides[i]);
    
    var limit = parseInt(this.dataset.limit) || 8;
    if (slides.length > limit) {
      for (var i = limit; i < slides.length; i++) {
        if (slides[i].parentNode) slides[i].parentNode.removeChild(slides[i]);
      }
    }
  };

  ProductRecommendations.prototype.initSlider = function() {
    var track = this.querySelector('.recommended-slider-track, .product-slider');
    var prevBtn = this.querySelector('.rec-prev');
    var nextBtn = this.querySelector('.rec-next');
    
    if(!track) return;

    var getSlideWidth = function() {
      var firstSlide = track.querySelector('.recommended-slide, .slider-item-wrap');
      return firstSlide ? firstSlide.offsetWidth + 20 : 240;
    };

    var updateArrows = function() {
      if (prevBtn) {
        if (track.scrollLeft <= 5) prevBtn.classList.add('hidden');
        else prevBtn.classList.remove('hidden');
      }
      if (nextBtn) {
        if (track.scrollLeft + track.offsetWidth >= track.scrollWidth - 5) nextBtn.classList.add('hidden');
        else nextBtn.classList.remove('hidden');
      }
    };

    if (prevBtn) prevBtn.onclick = function() { track.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' }); };
    if (nextBtn) nextBtn.onclick = function() { track.scrollBy({ left: getSlideWidth(), behavior: 'smooth' }); };
    track.onscroll = updateArrows;
    
    setTimeout(updateArrows, 200);
  };

  customElements.define('product-recommendations', ProductRecommendations);
}

document.addEventListener('DOMContentLoaded', function() {
  function getCardFiltersFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return {
      availability: params.get('pp_availability') || '',
      platform: params.get('pp_platform') || '',
      edition: params.get('pp_edition') || ''
    };
  }

  function setCardFilter(type, value) {
    var params = new URLSearchParams(window.location.search);
    var key = 'pp_' + type;
    if (!value || params.get(key) === value) params.delete(key);
    else params.set(key, value);
    params.delete('page');
    window.location.search = params.toString();
  }

  window.sortCardsByAvailability = function(scope) {
    scope = scope || document;
    var grids = scope.querySelectorAll('.product-grid');
    for (var i = 0; i < grids.length; i++) {
      var grid = grids[i];
      var cards = Array.prototype.slice.call(grid.children).filter(function(child) {
        return child.classList && child.classList.contains('product-card');
      });
      if (!cards.length) continue;
      cards.sort(function(a, b) {
        var av = a.getAttribute('data-available') === 'true' ? 0 : 1;
        var bv = b.getAttribute('data-available') === 'true' ? 0 : 1;
        return av - bv;
      });
      for (var j = 0; j < cards.length; j++) grid.appendChild(cards[j]);
    }
  };

  window.applyCardFilters = function(scope) {
    scope = scope || document;
    var contexts = [];
    if (scope.matches && scope.matches('[data-card-filter-bar]')) contexts.push(scope.parentNode || scope);
    var bars = scope.querySelectorAll ? scope.querySelectorAll('[data-card-filter-bar]') : [];
    for (var c = 0; c < bars.length; c++) {
      contexts.push(bars[c].parentNode || scope);
    }
    if (!contexts.length) return;

    var filters = getCardFiltersFromUrl();

    for (var x = 0; x < contexts.length; x++) {
      var context = contexts[x];
      var cards = context.querySelectorAll('.product-card');
      var visibleCount = 0;

      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var visible = true;
        var platforms = card.getAttribute('data-platforms') || '';
        var edition = card.getAttribute('data-edition') || '';
        var available = card.getAttribute('data-available') === 'true';

        if (filters.availability === 'in-stock' && !available) visible = false;
        if (filters.platform && platforms.indexOf(filters.platform) === -1) visible = false;
        if (filters.edition && edition !== filters.edition) visible = false;

        card.hidden = !visible;
        if (visible) visibleCount++;
      }

      var empty = context.querySelector('[data-card-filter-empty]');
      if (empty) empty.hidden = visibleCount !== 0;
    }

    var buttons = document.querySelectorAll('[data-card-filter]');
    for (var b = 0; b < buttons.length; b++) {
      var button = buttons[b];
      var type = button.getAttribute('data-card-filter');
      var value = button.getAttribute('data-value') || '';
      button.classList.toggle('is-active', filters[type] === value);
    }
  };

  window.filterRecommendationsByPlatform = function(section) {
    if (!section) return;
    var currentPlatforms = section.getAttribute('data-current-platforms') || '';
    if (!currentPlatforms) return;
    var track = section.querySelector('.recommended-slider-track, .product-slider');
    if (!track) return;
    var slides = track.querySelectorAll('.recommended-slide, .slider-item-wrap');
    var kept = 0;
    var keep = [];
    var remove = [];
    for (var i = 0; i < slides.length; i++) {
      var card = slides[i].querySelector('.product-card');
      if (!card) continue;
      var platforms = card.getAttribute('data-platforms') || '';
      var matches = platforms && currentPlatforms.split('|').some(function(platform) {
        return platform && platforms.indexOf(platform) !== -1;
      });
      if (matches) {
        keep.push(slides[i]);
        kept++;
      } else {
        remove.push(slides[i]);
      }
    }
    if (kept > 0) {
      for (var j = 0; j < keep.length; j++) track.appendChild(keep[j]);
      for (var r = 0; r < remove.length; r++) {
        if (remove[r].parentNode) remove[r].parentNode.removeChild(remove[r]);
      }
    }
  };

  document.addEventListener('click', function(event) {
    var filterButton = event.target.closest('[data-card-filter]');
    if (filterButton) {
      event.preventDefault();
      setCardFilter(filterButton.getAttribute('data-card-filter'), filterButton.getAttribute('data-value'));
      return;
    }
    var clearButton = event.target.closest('[data-card-filter-clear]');
    if (clearButton) {
      event.preventDefault();
      var params = new URLSearchParams(window.location.search);
      params.delete('pp_availability');
      params.delete('pp_platform');
      params.delete('pp_edition');
      window.location.search = params.toString();
    }
  });

  document.addEventListener('click', function(event) {
    var quick = event.target.closest('[data-product-card-quick-view]');
    if (!quick) return;
    event.preventDefault();
    event.stopPropagation();

    var card = quick.closest('.product-card');
    if (!card) return;
    var title = card.getAttribute('data-product-title') || 'Product';
    var platforms = (card.getAttribute('data-platforms') || '').split('|').filter(Boolean).join(', ') || 'Platform details on product page';
    var edition = card.getAttribute('data-edition') || 'Edition details on product page';
    var availability = card.getAttribute('data-available') === 'true' ? 'In stock' : 'Sold out';
    var price = card.querySelector('.price-val') ? card.querySelector('.price-val').textContent : '';
    var href = card.querySelector('.card-inner') ? card.querySelector('.card-inner').getAttribute('href') : '#';
    var variants = card.querySelector('.product-card-variants');

    var modal = document.getElementById('ProductQuickViewModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'ProductQuickViewModal';
      modal.className = 'product-quick-view-modal';
      modal.innerHTML = '<div class="product-quick-view-backdrop" data-product-quick-close></div><div class="product-quick-view-card" role="dialog" aria-modal="true"><button type="button" class="product-quick-view-close" data-product-quick-close aria-label="Close">x</button><p class="product-quick-view-kicker">Quick view</p><h2></h2><dl><div><dt>Availability</dt><dd data-qv-availability></dd></div><div><dt>Platform</dt><dd data-qv-platform></dd></div><div><dt>Edition</dt><dd data-qv-edition></dd></div><div><dt>Price</dt><dd data-qv-price></dd></div></dl><div class="product-quick-view-variants" data-qv-variants></div><a class="product-quick-view-link" href="#">View product details</a></div>';
      document.body.appendChild(modal);
    }
    modal.querySelector('h2').textContent = title;
    modal.querySelector('[data-qv-availability]').textContent = availability;
    modal.querySelector('[data-qv-platform]').textContent = platforms;
    modal.querySelector('[data-qv-edition]').textContent = edition;
    modal.querySelector('[data-qv-price]').textContent = price;
    var variantTarget = modal.querySelector('[data-qv-variants]');
    if (variantTarget) variantTarget.innerHTML = variants ? variants.innerHTML : '';
    modal.querySelector('.product-quick-view-link').setAttribute('href', href);
    modal.classList.add('active');
  });

  document.addEventListener('click', function(event) {
    if (!event.target.closest('[data-product-quick-close]')) return;
    var modal = document.getElementById('ProductQuickViewModal');
    if (modal) modal.classList.remove('active');
  });

  window.sortCardsByAvailability(document);
  window.applyCardFilters(document);

  function fixAppAccessibility() {
    var buttons = document.querySelectorAll('.tr-button, .btn, button, .settings-trigger');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (!btn.getAttribute('aria-label') && !btn.innerText.trim()) {
         btn.setAttribute('aria-label', btn.id || 'Action Button');
      }
    }
    var selects = document.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      if (!sel.getAttribute('aria-label')) sel.setAttribute('aria-label', sel.name || 'Selection Menu');
    }
    var links = document.querySelectorAll('a.cart-badge, .header-actions a');
    for (var k = 0; k < links.length; k++) {
      var link = links[k];
      if (!link.getAttribute('aria-label') && !link.innerText.trim()) {
        link.setAttribute('aria-label', 'Link');
      }
    }
  }

  if (window.requestIdleCallback) requestIdleCallback(fixAppAccessibility, { timeout: 2000 });
  else setTimeout(fixAppAccessibility, 1200);
});
